import { root } from './Divider.styles'
import { IDivider } from './Divider.types'

const Divider = (props: IDivider) => (
  <div data-testid='Divider' css={root(props)} />
)

export default Divider
